export enum ProjectHubEntryFilterType {
  OVERDUE = 'overdue',
  NO_OVERDUE = 'no_overdue',
}

export const projectHubEntryFilterTypeOptions = [
  ProjectHubEntryFilterType.OVERDUE,
  ProjectHubEntryFilterType.NO_OVERDUE,
];
